exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-49b89bd4] {\n  width: 600px;\n  margin: 0 auto;\n  background: #fafafa;\n  padding: 20px;\n  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  border-radius: 2px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/TestUpload/index.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,+CAA+C;UACvC,uCAAuC;EAC/C,mBAAmB;CACpB","file":"index.vue","sourcesContent":["\n.wrapper[data-v-49b89bd4] {\n  width: 600px;\n  margin: 0 auto;\n  background: #fafafa;\n  padding: 20px;\n  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49b89bd4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TestUpload/index.vue
// module id = 1056
// module chunks = 0